import React from 'react';
import { XIcon } from 'lucide-react';
export function WhatYouTriedSection() {
  const attempts = [{
    title: 'Improvisar',
    result: 'Te agota y te deja en el mismo lugar.'
  }, {
    title: 'Comprar papillas',
    result: 'Te quita el control.'
  }, {
    title: 'Guardar reels',
    result: 'No sabes por dónde empezar.'
  }, {
    title: 'Leer blogs',
    result: 'Terminas confundida.'
  }];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-baby-lavender" data-id="element-1368">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-1369">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-1370">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1371">
            Lo Que Ya Intentaste
          </h2>
          <p className="text-base sm:text-lg text-gray-600" data-id="element-1372">
            (Y por qué no funciona)
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 stagger-children" data-id="element-1373">
          {attempts.map((attempt, index) => <div key={index} className="bg-white/90 backdrop-blur-baby p-5 sm:p-6 rounded-baby-lg border-2 border-red-100 shadow-baby-soft" data-id="element-1374">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-1375">
                <div className="flex-shrink-0 w-8 h-8 bg-red-50 rounded-full flex items-center justify-center" data-id="element-1376">
                  <XIcon className="w-5 h-5 text-red-400" data-id="element-1377" />
                </div>
                <div data-id="element-1378">
                  <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-1379">
                    {attempt.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600" data-id="element-1380">
                    {attempt.result}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-baby-gradient-pink-blue p-6 sm:p-8 rounded-baby-lg text-white text-center shadow-baby-glow animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-1381">
          <p className="text-lg sm:text-xl md:text-2xl font-bold mb-2" data-id="element-1382">
            Nada de eso te da lo que necesitas:
          </p>
          <p className="text-base sm:text-lg opacity-95" data-id="element-1383">
            Un plan claro, seguro y adaptado a tu bebé.
          </p>
        </div>
      </div>
    </section>;
}